import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { GetTestCaseSummaryResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  children?: (data: GetTestCaseSummaryResponse) => ReactElement
}

const GetAiTestCasesSummaryRequest = ({
  id,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/test_cases/${id}/summary`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      url={url}
    />
  )
}

export default GetAiTestCasesSummaryRequest
